import { action } from 'typesafe-actions';

import { IDefaultShopConfig } from '../shopConfig/types';
import { DefaultShopTypes } from './types';

export const loadRequest = () => action(DefaultShopTypes.LOAD_REQUEST);
export const loadSuccess = (address: IDefaultShopConfig) =>
  action(DefaultShopTypes.LOAD_SUCCESS, address);
export const loadFailure = () => action(DefaultShopTypes.LOAD_FAILURE);
